<template>

  <div class="mycartall">

    <div class="backbtn">
      <backbtn></backbtn>
    </div>

    <div class="downpicbox" :style="{display:showdownpicbox}">
      <div id="vanshowp" class="vanshowpclass"></div>
    </div>
    <div class="downpicboxbg" v-if="showdownpic">
      <p class="closeicon" @click="closevanshow">
        <van-icon size="28px" name="cross" color="#fff" />
      </p>
      <p class="downtext">请长按图片选择保存图片到手机相册</p>
    </div>

    <div class="mycartbg global-full-fixed global-blur">
      <img :src="bg_url" onclick="return false" />
    </div>

    <div class="mycartshow">
      <div class="message-box">
        <!-- 1 -->
        <div class="toppic"><img :src="bg_url" /></div>
        <div class="align-center topbox">
          <div class="cu-avatar round lg weixin-img" v-if="mycartdata.avatar_url"><img :src="mycartdata.avatar_url" /></div>
          <div class="cu-avatar round lg weixin-img" v-else><img :src="morentx" /></div>
          <div class="topmessage-center">
            <div class="name-position">
              <p v-if="mycartdata.name">{{mycartdata.name}}</p>
              <p v-else>默认名称</p>
            </div>
            <div class="name-position02">
              <p v-if="mycartdata.job_title">{{mycartdata.job_title}}</p>
              <p v-else class="dwspbox">职称待完善</p>
            </div>
          </div>
        </div>

        <!-- 2 -->
        <div class="message-center cu-list menu">
          <div class="message-options" style="border-top:1px solid #eee; padding-top:0.35rem;">
            <div class="content flex grey-font-size">
              <div class="flex align-center">
                <img class="left-company-icons00 left-company-icons02" src="@/assets/images/home_icon_company.png" />
              </div>
              <p class="texts-greys text-location" v-if="mycartdata.company_name">{{mycartdata.company_name}}</p>
              <p class="texts-greys text-location" v-else>公司信息待完善</p>
            </div>
          </div>
          <div class="message-options">
            <div class="content grey-font-size">
              <div class="flex align-center">
                <img class="left-company-icons00" src="@/assets/images/home_icon_phone.png" />
              </div>
              <p class="texts-greys" v-if="mycartdata.tel">{{mycartdata.tel}}</p>
              <p class="texts-greys" v-else>{{myphone}}</p>
            </div>

          </div>
          <div class="message-options">
            <div class="content grey-font-size">
              <div class="flex align-center">
                <img class="left-company-icons00" src="@/assets/images/home_icon_wx.png" />
              </div>
              <p class="texts-greys" v-if="mycartdata.wx_no">{{mycartdata.wx_no}}</p>
              <p class="texts-greys" v-else>微信号待完善</p>
            </div>

          </div>
          <div class="message-options" style="border-bottom:1px solid #eee; padding-bottom:0.55rem;">
            <div class="content flex grey-font-size">
              <div class="flex align-center">
                <img class="left-company-icons00 left-company-icons02" src="@/assets/images/home_icon_adress.png" />
              </div>
              <p class="texts-greys text-location" v-if="mycartdata.location">{{mycartdata.location}}</p>
              <p class="texts-greys text-location" v-else>地理位置待完善</p>
            </div>
          </div>

        </div>

        <div class="downcartbox">
          <div class="cartewma">
            <img :src="mycartdata.applets_qrcode" />
          </div>
          <div class="carttext">
            <div>微信扫描或长按识别查看 更多名片信息</div>
            <p>(扫描免费制作)</p>
          </div>
        </div>
      </div>

      <div class="downbtnbox">
        <button class="edittobtn" @click="gotocartform">编辑信息</button>
        <button class="savetobtn" v-if="generatorevent" @click="generatorImage">保存图片</button>
        <button class="savetobtn" v-else @click="saveImage">保存图片</button>
      </div>
    </div>

    <div id="addImage" style="display:none;height:0; position: absolute; top:0;left:0; overflow:hidden;"></div>

    <div class="downloadcart">
      <div ref="thehtml">
        <div class="message-box">
          <!-- 1 -->
          <div class="toppic"><img :src="mycartdata.bg_url" /></div>
          <div class="align-center topbox">
            <div class="cu-avatar round lg weixin-img" v-if="mycartdata.avatar_url"><img :src="mycartdata.avatar_url" /></div>
            <div class="cu-avatar round lg weixin-img" v-else><img :src="morentx" /></div>
            <div class="topmessage-center">
              <div class="name-position">
                <p v-if="mycartdata.name">{{mycartdata.name}}</p>
                <p v-else>默认名称</p>
              </div>
              <div class="name-position02">
                <p v-if="mycartdata.job_title">{{mycartdata.job_title}}</p>
                <p v-else class="dwspbox">职称待完善</p>
              </div>
            </div>
          </div>

          <!-- 2 -->
          <div class="message-center cu-list menu">
            <div class="message-options" style="border-top:1px solid #eee; padding-top:0.65rem;">
              <div class="content flex grey-font-size">
                <div class="flex align-center">
                  <img class="left-company-icons00 left-company-icons02" src="@/assets/images/home_icon_company.png" />
                </div>
                <p class="texts-greys text-location" v-if="mycartdata.company_name">{{mycartdata.company_name}}</p>
                <p class="texts-greys text-location dwspbox" v-else>公司信息待完善</p>
              </div>
            </div>
            <div class="message-options">
              <div class="content grey-font-size">
                <div class="flex align-center">
                  <img class="left-company-icons00" src="@/assets/images/home_icon_phone.png" />
                </div>
                <p class="texts-greys" v-if="mycartdata.tel">{{mycartdata.tel}}</p>
                <p class="texts-greys" v-else>{{myphone}}</p>
              </div>

            </div>
            <div class="message-options">
              <div class="content grey-font-size">
                <div class="flex align-center">
                  <img class="left-company-icons00" src="@/assets/images/home_icon_wx.png" />
                </div>
                <p class="texts-greys" v-if="mycartdata.wx_no">{{mycartdata.wx_no}}</p>
                <p class="texts-greys" v-else>微信号待完善</p>
              </div>

            </div>
            <div class="message-options" style="border-bottom:1px solid #eee; padding-bottom:0.55rem;">
              <div class="content flex grey-font-size">
                <div class="flex align-center">
                  <img class="left-company-icons00 left-company-icons02" src="@/assets/images/home_icon_adress.png" />
                </div>
                <p class="texts-greys text-location" v-if="mycartdata.location">{{mycartdata.location}}</p>
                <p class="texts-greys text-location" v-else>地理位置待完善</p>
              </div>
            </div>

          </div>

          <div class="downcartbox">
            <div class="cartewma">
              <img :src="mycartdata.applets_qrcode" />
            </div>
            <div class="carttext">
              <div>微信扫描或长按识别查看 更多名片信息</div>
              <p>(扫描免费制作)</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <screen-capture ref="sc" :html="html"></screen-capture>

  </div>
</template>

<script>
import { getmycart } from "../../api/api";
import backbtn from "../public/backbtn";
import { Toast } from "vant";
import ScreenCapture from "../public/ScreenCapture";
import html2canvas from "html2canvas";
export default {
  name: "mycart",
  components: { ScreenCapture, backbtn },
  props: {
    msg: String
  },
  data () {
    return {
      html: null,
      mycartdata: [],
      myphone: "",
      morentx: require("../../assets/images/moren.jpg"),
      bg_url: window.localStorage.getItem("bgurl") || global.bgurl,
      showdownpic: false,
      showdownpicbox: 'block',
      generatorevent: true,
      imgsrc: '',
      titlename: "名片图"
    };
  },
  mounted () {
    this.html = this.$refs.thehtml;
  },
  created () {
    document.title = this.titlename;
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    getmycart()
      .then(res => {
        if (res.data.code == 200) {
          this.mycartdata = res.data.data;
          this.mycartdata.company_name =
            res.data.data.company_info.company_name;
          this.mycartdata.location = res.data.data.company_info.location;
          Toast.clear();
        } else {
          Toast.fail("加载失败！");
        }
      })
      .catch(err => {
      });

    this.myphone = localStorage.getItem("telphone");
  },
  methods: {
    closevanshow () {
      //let vanshowp = document.getElementById('vanshowp');
      this.showdownpicbox = 'none';
      this.showdownpic = false;
    },
    saveImage () {
      this.showdownpicbox = 'block';
      this.showdownpic = true;
    },
    gotocartform () {
      this.$router.push({
        name: "cartform",
        query: {
          userid: this.$route.query.userid
        }
      });
    },
    generatorImage () {
      let that = this;
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "海报下载中..."
      });

      let second = 3;
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = `海报下载中...`;
        } else {
          clearInterval(timer);
          Toast.clear();
        }
      }, 1000);

      this.$refs.sc.capture();
      let addImage = document.getElementById("addImage");

      setTimeout(download, 3000);

      function download () {
        let ocanvas = document.getElementsByTagName("canvas")[0];
        html2canvas(ocanvas).then(canvas => {
          //this.$refs.addImage.append(canvas);
          that.showdownpic = true;
          that.showdownpicbox = true;
          addImage.append(ocanvas);
          let link = document.createElement("img");
          link.src = canvas.toDataURL();
          link.style.display = "block";
          link.style.width = "100%"
          var vanshowp = document.getElementById("vanshowp");
          vanshowp.appendChild(link);
          that.generatorevent = false;
          setTimeout(downloadafter, 1500);
        });
      }


      function downloadafter () {
        Toast.success('请长按图片选择保存图片到相册');
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
@import "../../assets/css/reset.css";
.mycartall {
  height: 100%;
  width: 100%;
}
.mycartall .mycartbg {
  height: 100%;
  position: fixed;
  z-index: 0;
  width: 100%;
  overflow: hidden;
}
.mycartall .mycartbg img {
  height: 100%;
}
.mycartall .mycartshow {
  height: 100%;
  width: 18.65rem;
  margin: 0 auto;
  margin-top: 0.3rem;
  position: relative;
  z-index: 1;
}

.mycartall .backbtn {
  position: fixed;
  left: 1rem;
  top: 1rem;
}

.mycartall .mycartshow .message-box .topbox {
  overflow: hidden;
  padding-left: 0.65rem;
  padding-top: 0.25rem;
}
.mycartall .mycartshow .message-box .topbox .weixin-img {
  float: left;
}
.mycartall .mycartshow .message-box .topbox .weixin-img img {
  width: 3.25rem;
  border-radius: 50%;
}
.mycartall .mycartshow .message-box .topbox .topmessage-center {
  float: left;
  padding-left: 0.81rem;
}
.mycartall .mycartshow .message-box .topbox .topmessage-center .name-position {
  font-size: 0.92rem;
  color: #333;
  padding-top: 0.29rem;
}
.mycartall
  .mycartshow
  .message-box
  .topbox
  .topmessage-center
  .name-position02 {
  font-size: 0.757rem;
  color: #666;
  padding-top: 0.38rem;
}

.mycartall .mycartshow .message-box .message-options {
  overflow: hidden;
  margin-left: 0.65rem;
  margin-right: 0.65rem;
  margin-top: 0.48rem;
  margin-bottom: 0.8rem;
}
.mycartall .mycartshow .message-box .message-options .left-company-icons00 {
  float: left;
}
.mycartall .mycartshow .message-box .message-options .align-center {
  padding-right: 0.65rem;
  float: left;
}
.mycartall
  .mycartshow
  .message-box
  .message-options
  .align-center
  img.left-company-icons00 {
  height: 1.081rem;
}
.mycartall .mycartshow .message-box .message-options .content .texts-greys {
  font-size: 0.76rem;
  float: left;
  width: 15.135rem;
  color: #666;
}

.global-full-fixed {
  z-index: -1;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

/* 毛玻璃效果 */
.global-blur {
  /* FireFox, Chrome, Opera */
  background-position: center;
  background-size: cover;
  background-position: 45% 50%;
  height: 100%;
  -webkit-filter: blur(6px);
  /* Chrome, Opera */
  -moz-filter: blur(6px);
  -ms-filter: blur(6px);
  filter: blur(6px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=10, MakeShadow=false);
  /* IE6~IE9 */
}

.dwspbox i {
  font-style: normal;
  padding-left: 0.3rem;
  padding-top: 0.1rem;
}
.mycartall .mycartshow .message-box {
  width: 100%;
  border-radius: 40px 10px;
  background: #fff;

  overflow: hidden;
}

.mycartall .mycartshow .message-box .toppic {
}
.mycartall .mycartshow .message-box .toppic img {
  width: 100%;
  border-radius: 40px 10px 0 0;
}

.mycartall .mycartshow .message-box .message-top {
  padding: 0.7837837837837838rem 0.6756756756756757rem;
  position: relative;
  color: #666666;
  background: #fff;
  /* height: 200rpx; */
}

.mycartall .mycartshow .message-box .downcartbox {
  clear: both;
  overflow: hidden;

  padding-bottom: 0.3rem;
}
.mycartall .mycartshow .message-box .downcartbox .cartewma {
  float: left;
  padding-left: 2.5675675675675675rem;
}
.mycartall .mycartshow .message-box .downcartbox .cartewma img {
  width: 3.7837837837837838rem;
  height: 3.7837837837837838rem;
}
.mycartall .mycartshow .message-box .downcartbox .carttext {
  float: left;
  margin-left: 2.2972972972972974rem;
  width: 7.945945945945946rem;
}

.mycartall .mycartshow .message-box .downcartbox .carttext div {
  color: #333;
  line-height: 1.0810810810810811rem;
  padding-top: 0.40540540540540543rem;
  font-size: 0.7027027027027027rem;
}

.mycartall .mycartshow .message-box .downcartbox .carttext p {
  color: #999;
  font-size: 0.6486486486486487rem;
}

.mycartall .mycartshow .message-box .topbox .weixin-img {
  float: left;
}
.mycartall .mycartshow .message-box .topbox .weixin-img img {
  width: 3.25rem;
  border-radius: 50%;
}
.mycartall .mycartshow .message-box .topbox .topmessage-center {
  float: left;
  padding-left: 0.81rem;
}
.mycartall .mycartshow .message-box .topbox .topmessage-center .name-position {
  font-size: 0.92rem;
  color: #333;
  padding-top: 0.29rem;
}
.mycartall
  .mycartshow
  .message-box
  .topbox
  .topmessage-center
  .name-position02 {
  font-size: 0.757rem;
  color: #666;
  padding-top: 0.38rem;
}

.mycartall .mycartshow .message-box .message-options {
  overflow: hidden;
  margin-left: 0.65rem;
  margin-right: 0.65rem;
  margin-top: 0.38rem;
  margin-bottom: 0.6rem;
}
.mycartall .mycartshow .message-box .message-options .left-company-icons00 {
  float: left;
}
.mycartall .mycartshow .message-box .message-options .align-center {
  padding-right: 0.65rem;
  float: left;
}
.mycartall
  .mycartshow
  .message-box
  .message-options
  .align-center
  img.left-company-icons00 {
  height: 1.081rem;
}
.mycartall .mycartshow .message-box .message-options .content .texts-greys {
  font-size: 0.76rem;
  float: left;
  width: 15.135rem;
  color: #666;
}

.mycartall .downloadcart {
  width: 18.65rem;
  position: absolute;
  top: 0.3rem;
  background: #fff;
  border-radius: 40px 10px 40px 10px;
  left: 50%;
  margin-left: -9.325rem;
  z-index: -5;
}
.mycartall .downloadcart .message-box {
  width: 18.65rem;
  margin: 0 auto;
  overflow: hidden;
}
.mycartall .downloadcart .message-box .downcartbox {
  clear: both;
  overflow: hidden;
  padding-bottom: 0.5rem;
}
.mycartall .downloadcart .message-box .downcartbox .cartewma {
  float: left;
  padding-left: 2.5675675675675675rem;
}
.mycartall .downloadcart .message-box .downcartbox .cartewma img {
  width: 3.7837837837837838rem;
  height: 3.7837837837837838rem;
}
.mycartall .downloadcart .message-box .downcartbox .carttext {
  float: left;
  margin-left: 2.2972972972972974rem;
  width: 7.945945945945946rem;
}

.mycartall .downloadcart .message-box .downcartbox .carttext div {
  color: #333;
  line-height: 1.0810810810810811rem;
  padding-top: 0.40540540540540543rem;
  font-size: 0.7027027027027027rem;
}

.mycartall .downloadcart .message-box .downcartbox .carttext p {
  color: #999;
  font-size: 0.6486486486486487rem;
}

.mycartall .downloadcart .message-box .toppic {
}
.mycartall .downloadcart .message-box .toppic img {
  width: 100%;
}

.mycartall .downloadcart .message-box .message-top {
  padding: 0.7837837837837838rem 0.6756756756756757rem;
  position: relative;
  color: #666666;
  background: #fff;
  /* height: 200rpx; */
}

.mycartall .downloadcart .message-box .topbox {
  overflow: hidden;
  padding-left: 0.65rem;
  padding-top: 0.55rem;
}
.mycartall .downloadcart .message-box .topbox .weixin-img {
  float: left;
}
.mycartall .downloadcart .message-box .topbox .weixin-img img {
  width: 3.25rem;
  border-radius: 50%;
}
.mycartall .downloadcart .message-box .topbox .topmessage-center {
  float: left;
  padding-left: 0.81rem;
}
.mycartall
  .downloadcart
  .message-box
  .topbox
  .topmessage-center
  .name-position {
  font-size: 0.92rem;
  color: #333;
  padding-top: 0.29rem;
}
.mycartall
  .downloadcart
  .message-box
  .topbox
  .topmessage-center
  .name-position02 {
  font-size: 0.757rem;
  color: #666;
  padding-top: 0.38rem;
}

.mycartall .downloadcart .message-box .message-options {
  overflow: hidden;
  margin-left: 0.65rem;
  margin-right: 0.65rem;
  margin-top: 0.38rem;
  margin-bottom: 0.8rem;
}
.mycartall .downloadcart .message-box .message-options .left-company-icons00 {
  float: left;
}
.mycartall .downloadcart .message-box .message-options .align-center {
  padding-right: 0.65rem;
  float: left;
}
.mycartall
  .downloadcart
  .message-box
  .message-options
  .align-center
  img.left-company-icons00 {
  height: 1.081rem;
}
.mycartall .downloadcart .message-box .message-options .content .texts-greys {
  font-size: 0.76rem;
  float: left;
  width: 15.135rem;
  color: #666;
}

.downbtnbox {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.downbtnbox .savetobtn {
  height: 2.4324324324324325rem;
  margin: 0;
  color: #ffffff;
  line-height: 2.4324324324324325rem;
  margin-top: 0.3rem;
  border-radius: 1.3513513513513513rem;
  width: 8.91891891891892rem;
  background: linear-gradient(90deg, #88d32d, #a7ef4b);
  text-align: center;
  color: #fff;
  font-size: 0.7567567567567568rem;
  margin-left: 0.2702702702702703rem;
  border: none;
}
.downbtnbox .edittobtn {
  height: 2.4324324324324325rem;
  margin: 0;
  color: #ffffff;
  line-height: 2.4324324324324325rem;
  margin-top: 0.3rem;
  border-radius: 1.3513513513513513rem;
  width: 8.91891891891892rem;
  background: linear-gradient(90deg, #ffbd0a, #f9da5b);
  text-align: center;
  color: #fff;
  font-size: 0.7567567567567568rem;
  margin-right: 0.40540540540540543rem;
  border: none;
}

.closeicon {
  text-align: right;
  padding-right: 1rem;
  padding-top: 0.8rem;
}
.downpicbox {
  position: fixed;
  width: 86%;
  left: 7%;
  top: 3rem;
  z-index: 10;
}
.downpicbox #vanshowp {
  width: 100%;
}
.mycartall .downpicbox .vanshowpclass img {
  width: 200px;
}
.downpicboxbg .downtext {
  color: #fff;
  text-align: center;
  font-size: 0.75rem;
  position: absolute;
  bottom: 1rem;
  width: 100%;
}
.downpicboxbg {
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/mycart.vue